export var POSITIONING_PROPS = ['position', 'top', 'right', 'bottom', 'left'];
export var STATUS = {
    INIT: 'init',
    IDLE: 'idle',
    RENDER: 'render',
    OPENING: 'opening',
    OPEN: 'open',
    CLOSING: 'closing',
    ERROR: 'error',
};
//# sourceMappingURL=literals.js.map